import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";
import { FaqList } from "@/components/home/FaqTeaser";

export default function Faq() {
  const { t } = useI18n();
  return (
    <div data-testid="faq-page">
      <PageHero eyebrow={t.faq.eyebrow} title={t.faq.title} />
      <section className="container-x pb-28">
        <div className="max-w-4xl"><FaqList items={t.faq.items} /></div>
        <Link to="/commander" data-testid="faq-order-btn" className="mt-12 inline-flex bg-[var(--gold)] px-8 py-4 text-sm font-bold uppercase tracking-[0.16em] text-[var(--night)]">{t.common.order}</Link>
      </section>
    </div>
  );
}
